import { MIN_TEMPLATE_CODE_SLUG_LENGTH } from '../config';

export const generateCodeFromName = (name: string): string => {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');
};

// Math.random() can yield fewer than six base-36 digits (e.g. 0.5 → "0.i").
const generateRandomSuffix = (): string =>
  Math.random().toString(36).substring(2, 8).padEnd(6, '0');

const withRandomSuffix = (slug: string): string =>
  `${slug || 'template'}_${generateRandomSuffix()}`;

// Names in non-Latin scripts slug to nothing or to a stray digit, while the
// backend requires a non-empty code, so such names get a random code instead.
export const generateTemplateCode = (name: string): string => {
  const slug = generateCodeFromName(name);

  return slug.length >= MIN_TEMPLATE_CODE_SLUG_LENGTH
    ? slug
    : withRandomSuffix(slug);
};

export const generateUniqueTemplateCode = (name: string): string =>
  withRandomSuffix(generateCodeFromName(name));

export const generateSectionCode = (): string =>
  `section_${generateRandomSuffix()}`;
